
export default {
  goalsBy: "Vendor",
  addressVerification: ($session) => ($session.isOffline() ? false : true),
  hideCustomerNotesVendor: false,
  hideCustomerNotesConfirmation: true,
  hideAddCustomerNotes: false,
  hideCustomerAdd: false,
  hideCustomerEdit: false,
  hideEditContact: false,
  hideAddContact: false,
  hideAddActivity: false,
  hideCustomerInactive: false,
  hideManagerCustomerInactive: false,
  hideAccountTypeInGrid: true,
  hideDeleteCustomer: false,
  showBulkActions: true,
  showScanBadge: false,
  hideCallReport: true,
  listFields: "",
  registrationStatusMakeActive: ["Completed", "Approved"],
  useOriginalCustomerIdFallabck: false,
  filters: [
    { groupBy: "Status" },
    { date: "CreatedOn", title: "Created Date" },
    { date: "LastOrderedOn", title: "Last Order Date" },
    {
      groupBy: "SalesRepName",
      title: "Sales Rep",
      maxHeight: 200,
      collapsed: true,
    },
    //{ groupBy: "City", maxHeight: 200, collapsed: true },
    { groupBy: "State", maxHeight: 200, collapsed: true },
    {
      groupBy: "AccountType",
      title: "Store Type",
      maxHeight: 200,
      collapsed: true,
    },
  ],
};
